// extracted by css-extract-rspack-plugin
export default {"cls1":"MentionsCardHeader-cls1_07S","cls2":"MentionsCardHeader-cls2_0XK MentionsCardHeader-cls1_07S"};